export default __webpack_public_path__ + "static/media/image_firstReview.4a534aa1.jpg";